import warn from './warn';

export default class SingleEventEmitter {
  constructor(defaultValue) {
    this.listeners = new Map();
    this.latest = defaultValue;
  }

  on(cb) {
    this.listeners.set(cb, cb);
  }

  off(cb) {
    if (!this.listeners.delete(cb)) {
      warn(`You tried detaching an event handler that's not listening on anything.`);
    }
  }

  emit(value) {
    this.listeners.forEach(listener => listener(value));
    this.latest = value;
  }
}
